import React from 'react'

//styles
import "./CatalogoAdmin.css"
import CardComponent from '../../Components/CardComponent/CardComponent'
import { Tabs, TabsProps } from 'antd';
import ProductsAdmin from '../Products/ProductosAdmin';
import CardsAdmin from '../Products/CardsAdmin';

const CatalogoAdmin = () => {
    const [viewTab, setViewTab] = React.useState<String>("1");
    

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'Productos',
  },
  {
    key: '3',
    label: 'Cartas',
  },
];

    const onChange = (key: string) => {
    setViewTab(key);
    };


  return (
    <div className='CatalogoAdmin-layout'>
        <div className='CatalogoAdmin-Header'>
            <div className='CatalogoAdmin-left'>
                <span className='CatalogoAdmin-title'>Catalogo Administrativo</span>

                <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            </div>
            <div className='CatalogoAdmin-rigth'>

                <div className='CatalogoAdmin-cartButton'>
                    <CardComponent ></CardComponent>
                </div>

            </div>

        </div>
        <div className='CatalogoAdmin-Body'>
        {   viewTab=="1" ? <ProductsAdmin /> :
            <CardsAdmin />

        }
        </div>
    </div>
  )
}

export default CatalogoAdmin